import { Button, Grid, Steps } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../layouts/components";

import { useLocation, useNavigate } from "react-router-dom";
import { NoData } from "../../components";
import { SearchResponse } from "../../hooks/Search/data";
import { useGetSessions } from "../../hooks/Search/search.hooks";
import { objectToQuerystring } from "../../plugins/utils";
import { DataEntry, Payment, SearchResult } from "./components";
import { paymentStatusEnum } from "./enumerations/paymentStatusEnum";
import { steps } from "./enumerations/steps";
import styles from "./styles.module.scss";

const useQueryParams = () => {
  const { search } = useLocation();
  return Object.fromEntries(new URLSearchParams(search));
};

const Result: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    step: stepState,
    cartItems,
    nickname,
    total_amount,
  } = location.state || {};
  const { useBreakpoint } = Grid;
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [currentStep, setCurrentStep] = useState<number | undefined>(undefined);
  const [paymentNumber, setPaymentNumber] = useState<string | undefined>(
    undefined
  );
  const [paymentStatus, setPaymentStatus] = useState<string | undefined>(
    paymentStatusEnum.PENDING
  );
  const [selectedItem, setSelectedItem] = useState<SearchResponse[]>([]);

  const [queryParams, setQueryParams] = useState<any>(useQueryParams());

  const { data: results, isLoading: loadingResult } = useGetSessions(
    { ...queryParams },
    { enabled: currentStep === steps.SEARCH }
  );

  const onChangeStep = (step: number) => {
    switch (step) {
      case steps.PAY:
        const queryString = objectToQuerystring({ ...queryParams, step: step });
        setQueryParams({ ...queryParams, step: step });
        navigate(`/search/?${queryString}`, {
          replace: true,
          state: { nickname: nickname },
        });
        break;
      case steps.DATA:
        // navigate(`/search/?step=${step}&payment_number=&status=`);
        break;
      default:
        break;
    }
    // if(step ===steps.)

    // setCurrentStep(step);
  };

  useEffect(() => {
    console.debug("paymentNumber", paymentNumber);
    console.debug("paymentStatus", paymentStatus);
  }, [paymentNumber, paymentStatus]);

  useEffect(() => {
    console.debug("currentStep", currentStep);
  }, [currentStep]);

  useEffect(() => {
    if (cartItems) {
      console.debug("cartItems", cartItems);
    }
  }, [cartItems]);

  const renderContent = () => {
    switch (currentStep) {
      case steps.SEARCH:
        return (
          <SearchResult
            onChangeStep={onChangeStep}
            searchResult={results}
            loadingResult={loadingResult}
            nickname={nickname}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        );
      case steps.PAY:
        return (
          <Payment
            searchResult={selectedItem.length > 0 ? selectedItem : cartItems}
            loadingResult={loadingResult}
            onChangeStep={onChangeStep}
            paymentNumber={paymentNumber}
            totalAmount={total_amount}
            setPaymentNumber={setPaymentNumber}
          />
        );
      case steps.DATA:
        return (
          <DataEntry
            // searchResult={results}
            paymentNumber={paymentNumber}
            paymentStatus={paymentStatus}
          />
        );
      default:
        break;
    }
  };

  useEffect(() => {
    console.debug("queryParams", queryParams);
    if (!queryParams.step) setCurrentStep(steps.SEARCH);
    setCurrentStep(Number(queryParams.step));
    if (queryParams.payment_number)
      setPaymentNumber(queryParams.payment_number);
    if (queryParams.status) setPaymentStatus(queryParams.status);
  }, [queryParams]);

  useEffect(() => {
    if (results && results.length === 1) {
      setSelectedItem([results[0]]);
    }
  }, [results]);

  return (
    <ContentWrapper>
      {results?.length > 0 ||
      cartItems?.length > 0 ||
      loadingResult ||
      (currentStep && [steps.DATA, steps.PAY].includes(currentStep)) ? (
        <div className={styles.searchResultContainer}>
          <Steps
            className={`${styles.step} ${screens.sm ? "" : styles.mobile}`}
            current={currentStep}
            labelPlacement={"vertical"}
            responsive={false}
            items={[
              {
                title: t("checkout.step.search"),
              },
              {
                title: t("checkout.step.pay"),
              },
              {
                title: t("checkout.step.data"),
              },
            ]}
          />
          {renderContent()}
        </div>
      ) : (
        <NoData
          title={t("search.nodata.title")}
          subtitle={
            <div style={{ textAlign: "center" }}>
              <span>{t("search.nodata.subtitle1")}</span>
              <a>{t("auth.footer.buttoncs")}</a>
              <span>{t("search.nodata.subtitle2")}</span>
            </div>
          }
          offsetTop={80}
          additionalItem={
            <Button
              block={screens.sm ? false : true}
              className={styles.btnSearch}
              type="primary"
              onClick={() => navigate(-1)}
            >
              {t("search.nodata.searchagain")}
            </Button>
          }
        />
      )}
    </ContentWrapper>
  );
};

export default Result;
